var map = {
  "./beijing.png": "22500",
  "./gongshang.png": "4587",
  "./guangda.png": "75668",
  "./guangfa.png": "82010",
  "./guangzhou.png": "61863",
  "./huaxia.png": "50005",
  "./jianshe.png": "80969",
  "./jiaotong.png": "21152",
  "./laishang.png": "89992",
  "./mingsheng.png": "79768",
  "./nanjing.png": "92912",
  "./ningbo.png": "25106",
  "./nongye.png": "2167",
  "./paytips.png": "73877",
  "./pingan.png": "63408",
  "./pufa.png": "95067",
  "./qilu.png": "98974",
  "./qingdao.png": "82984",
  "./shanghai.png": "13026",
  "./weishang.png": "85433",
  "./xiamen.png": "14491",
  "./xingye.png": "68979",
  "./youzheng.png": "99808",
  "./zhaoshang.png": "45756",
  "./zheshang.png": "94771",
  "./zhongguo.png": "33894",
  "./zhongxin.png": "18540"
};


function __rspack_context(req) {
  var id = __rspack_context_resolve(req);
  return __webpack_require__(id);
}
function __rspack_context_resolve(req) {
  if(!__webpack_require__.o(map, req)) {
    var e = new Error("Cannot find module '" + req + "'");
    e.code = 'MODULE_NOT_FOUND';
    throw e;
  }
  return map[req];
}
__rspack_context.keys = function webpackContextKeys() {
  return Object.keys(map);
};
__rspack_context.resolve = __rspack_context_resolve;
module.exports = __rspack_context;
__rspack_context.id = 67000;
